<template>
  <div class="dropdown-time-type-3">
    <div class="box">
      <span class="box-title">{{ tempBoxTitle }}</span>
      <span class="title" aria-readonly="true">{{ tempTitle }}</span>
      <div class="over-button-box" @click.stop="show"></div>
      <div class="dropdown-box">
        <ul>
          <li class="title-li">FROM</li>
          <li
            v-for="(item, index) of 24"
            v-bind:key="index"
            @click.stop="fromTime(index)"
            :class="{ 'active-time': fromTimeIndex === index }"
          >
            {{ convertTime(item) }}
          </li>
        </ul>
        <ul>
          <li class="title-li">TO</li>
          <li
            v-for="(item, index) of 25"
            v-bind:key="index"
            @click="toTime(index)"
            :style="{ display: fromTimeIndex < index ? '' : 'none' }"
            :class="{ 'active-time': toTimeIndex === index }"
          >
            {{ convertTime(item) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types'

export default {
  name: 'dropdown-time-type-3',
  props: {
    propBoxTitle: {
      default: 'TIME',
      type: String
    },
    propTitle: {
      default: 'Any time',
      type: String
    }
  },
  data() {
    return {
      tempTitle: '',
      tempIndex: null,
      tempBoxTitle: '',
      timeList: [],
      fromTimeTitle: '',
      toTimeTitle: '',
      fromTimeIndex: '',
      toTimeIndex: '',
      convertTimeSet: 60
    }
  },
  created() {
    this.tempTitle = this.propTitle
    this.tempBoxTitle = this.propBoxTitle
  },
  mounted() {},
  methods: {
    convertTime(time) {
      const hour = Number(time) - 1
      // console.log('time:', hour)
      const _time = hour < 10 ? `0${hour}:00` : `${hour}:00`
      const type = hour < 13 ? 'AM' : 'PM'
      return `${_time} ${type}`
    },
    /**
     * Click the button to display the corresponding child elements.
     * @param event
     */
    show(event) {
      const el = event.target
      const elChild = el.nextElementSibling // Binding child element.
      // console.log(el.parentElement)
      el.parentElement.className += ' active'
      if (elChild.className === 'dropdown-box') {
        this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
        elChild.className += ' active'
      } else {
        elChild.className = 'dropdown-box'
      }
    },
    fromTime(index) {
      console.log('fromTime:', index)
      this.fromTimeTitle = this.convertTime(index + 1)
      this.fromTimeIndex = index
      this.toTimeTitle = ''
      this.toTimeIndex = ''
      this.setValue()
    },
    toTime(index) {
      this.toTimeTitle = this.convertTime(index + 1)
      this.toTimeIndex = index
      this.setValue()
    },
    setValue() {
      this.tempTitle = this.fromTimeTitle + ' ~ ' + this.toTimeTitle
      const selectedTime = {
        [this.fromTimeIndex * 60]: {
          endTime: this.toTimeIndex * 60
        }
      }
      this.$emit('input', selectedTime)
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-time-type-3 {
  // Actions to prevent other stylesheets from affecting.
  position: relative;
  display: inline;
  float: left;
  border: 1px solid #dbdbdb;
  width: 271px;
  .box {
    &:hover {
      background-color: rgb(23, 33, 251);
      color: #fff;
    }
    position: relative;
    height: 80px;
    width: inherit;
    background-image: url('../../assets/images/down-arrow.svg');
    background-position-y: 49px;
    background-position-x: 235px;
    background-repeat: no-repeat;

    .box-title {
      position: absolute;
      top: 15px;
      left: 20px;
      font-weight: 600;
    }

    .title {
      position: absolute;
      top: 43px;
      left: 20px;
      font-weight: 300;
    }

    .over-button-box {
      cursor: pointer;
      position: inherit;
      width: inherit;
      height: inherit;
    }
    //noinspection ALL
    .dropdown-box {
      height: 0;
      z-index: -1;
      overflow-y: scroll;
      overflow-x: hidden;
      position: absolute;
      left: -1px;
      background-color: rgba(255, 255, 255, 1);
      width: inherit;
      z-index: 9999;
      color: #000;
      opacity: 0;
      visibility: hidden;
      padding: 10px 0;
      border: 1px solid #dbdbdb;
      display: flex;

      -webkit-transition-property: width height background-color font-size left
        top transform -webkit-transform color;
      -webkit-transition-duration: 0.3s;
      -webkit-transition-timing-function: ease-in-out;

      -moz-transition-property: width height background-color font-size left top
        transform -moz-transform color;
      -moz-transition-duration: 0.3s;
      -moz-transition-timing-function: ease-in-out;

      -ms-transition-property: width height background-color font-size left top
        transform -ms-transform color;
      -ms-transition-duration: 0.3s;
      -ms-transition-timing-function: ease-in-out;

      -o-transition-property: width height background-color font-size left top
        transform -o-transform color;
      -o-transition-duration: 0.3s;
      -o-transition-timing-function: ease-in-out;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;

      ul {
        .title-li {
          font-size: 16px;
          font-weight: 600;
        }
        width: 50%;
      }

      li {
        cursor: pointer;
        line-height: 30px;
        padding: 0 0 0 25px;
      }

      li[item]:hover {
        color: #ffffff;
        background-color: #1f33f7;
        -webkit-transition-property: background-color transform -webkit-transform
          color;
        -webkit-transition-duration: 0.3s;
        -webkit-transition-timing-function: ease-in-out;

        -moz-transition-property: background-color transform -moz-transform color;
        -moz-transition-duration: 0.3s;
        -moz-transition-timing-function: ease-in-out;

        -ms-transition-property: background-color transform -ms-transform color;
        -ms-transition-duration: 0.3s;
        -ms-transition-timing-function: ease-in-out;

        -o-transition-property: background-color transform -o-transform color;
        -o-transition-duration: 0.3s;
        -o-transition-timing-function: ease-in-out;

        transition-property: background-color transform transform color;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;
      }

      .active-time {
        color: #ffffff;
        background-color: #1f33f7;
      }
    }

    //noinspection ALL
    .active {
      height: 200px;
      z-index: 1000;
      opacity: 1;
      visibility: visible;

      -webkit-transition-property: width height background-color font-size left
        top transform -webkit-transform color;
      -webkit-transition-duration: 0.3s;
      -webkit-transition-timing-function: ease-in-out;

      -moz-transition-property: width height background-color font-size left top
        transform -moz-transform color;
      -moz-transition-duration: 0.3s;
      -moz-transition-timing-function: ease-in-out;

      -ms-transition-property: width height background-color font-size left top
        transform -ms-transform color;
      -ms-transition-duration: 0.3s;
      -ms-transition-timing-function: ease-in-out;

      -o-transition-property: width height background-color font-size left top
        transform -o-transform color;
      -o-transition-duration: 0.3s;
      -o-transition-timing-function: ease-in-out;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
    }
  }

  .active {
    background-color: rgb(245, 245, 245);
  }
}
</style>
